import { Text, Stack, StackItem } from '@fluentui/react';
import { FluentProvider, LargeTitle, Image, Button, Body2 } from '@fluentui/react-components';
import { signLogo, dashboardTheme } from '../../styles/customStyles';
import { SignOut20Regular } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';

export const Restricted = () => {
    const navigate = useNavigate();
    const handleSignOut = () => (localStorage.clear(), sessionStorage.clear(), navigate('/'));

    const signoutButton = (
        <Button shape="circular" size="large" appearance="outline" onClick={handleSignOut} icon={<SignOut20Regular />} iconPosition="after">
            <Body2> Sign out </Body2>
        </Button>
    );

    return (
        <Stack grow verticalFill tokens={{ childrenGap: 100 }}>
            <FluentProvider theme={dashboardTheme}>
                <StackItem>
                    <Image src="/Dashboard/image/signinLogo.svg" alt="Nanoheal" style={signLogo} />
                    {/* {signoutButton} */}
                </StackItem>
            </FluentProvider>
            <Stack horizontal tokens={{ childrenGap: 400 }}>
                <StackItem><Text></Text></StackItem>
                <StackItem><Stack verticalFill horizontalAlign="center" tokens={{ childrenGap: 20, padding: 30 }}>
                    <LargeTitle> SSO Request Submitted </LargeTitle>
                    <Stack>
                        <Body2 align='justify'>
                            Your Single Sign-On (SSO) request has been sent to the Administrator for approval. Please contact your admin to obtain the
                            necessary approval to access the Management Portal. Thank you for your patience.
                        </Body2>
                    </Stack>
                    {signoutButton}
                </Stack></StackItem>
                <StackItem><Text></Text></StackItem>
            </Stack>
        </Stack>
    );
};
